export enum HIRO_EVENT_NAME {
    SUMMARY = 'hiro:summary',
    TRANSLATE = 'hiro:translate',
    HIRO_LOADED = 'hiro:loaded',
    NEW_CHAT = 'hiro:new-chat',
}

export const HIRO_EVENT_PROXY = Symbol.for('HIRO_EVENT_PROXY');
